/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
(function () {
  'use strict';

  angular.module('comcast.settings').controller('UploadGroupSearchController', ['$state', '$stateParams', function ($state, $stateParams) {
    /* PRIVATE : DATA */
    //Declare all private variables here

    /*
     * This is the `vm` object. It is a direct reference to the controller
     * which acts as our 'view-model' in angular. It also limits our need
     * to be accessing $scope directly. */

    /*jshint validthis:true*/
    var vm = this;
    /* BINDABLE : DATA */

    vm.searchParams = {
      includeDisabled: false
    };
    /* BINDABLE : METHODS*/

    vm.search = search;
    vm.clear = clear;
    /* INITIALIZATION */
    //Call controller initialization method here

    _init();
    /* IMPLEMENTATION : BINDABLE */


    function search() {
      $state.go('uploadgroup', vm.searchParams, {
        notify: true,
        inherit: false,
        reload: true
      });
    }

    function clear() {
      vm.searchParams = {
        includeDisabled: false
      };
    }
    /**
     * Initialization for this controller.
     */


    function _init() {
      vm.searchParams = $stateParams;
    }
  }]);
})();